import { defineSaleProgress, hasAddress, isSaleCreated, type ProgressSaleData, type SaleStatus } from '../saleProgress'
import type { ScriptSteps } from '../scripts/blocks/stages'

export interface EddyProgressData extends ProgressSaleData {
  team?: string | null
  tenantType?: string | null
  scriptSteps?: ScriptSteps | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export const isEddyLinkOpened = (data: EddyProgressData) => !!data.scriptSteps?.extLink

export default defineSaleProgress<EddyProgressData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'link_opened', label: `${TIMELINE}link_opened`, done: isEddyLinkOpened },
    { key: 'created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps): SaleStatus => {
    if (steps[steps.length - 1]?.state === 'done') return 'signed'
    const isInProgress =
      steps.some(step => step.state === 'done') || !!data.team || !!data.tenantType || !!data.actionsInProgress
    if (isInProgress) return 'progress'

    return 'new'
  },
})
